import { CommonService } from 'shared/services/common.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { PreloaderService } from '../../services/preloader.service';

import { PaymentApi, PurchaseOrderApi, InvoiceApi } from '../../sdk';

@Component({
  selector: 'app-pay-detail',
  templateUrl: './payment-detail.component.html',
  styleUrls: ['./payment-detail.component.css']
})
export class PayDetailComponent implements OnInit {
  @Input() modelName: string;
  @Input() modelId: string;
  paymentDetailTab: boolean = true;

  payment: any;
  order: any;
  invoice: any;
  errorMessage: string;
  timeZone: any;

  constructor(
    private paymentApi: PaymentApi,
    private purchaseOrderApi: PurchaseOrderApi,
    private invoiceApi: InvoiceApi,
    private preloaderService: PreloaderService,
    private _commonService: CommonService
  ) { }

  ngOnInit() {
    this._commonService.getUserProfile().subscribe(userProfile => {
      if (userProfile) {
        this.timeZone = userProfile['timezone'];
      }
    }, error => {
      console.log(error);
    })
    if (
      this.modelName === 'undefined' ||
      this.modelName.toLowerCase() === 'invoice'
    ) {
      this.getPaymentDetails({ sfdcId: this.modelId });
    }
    if (this.modelName.toLowerCase() === 'job') {
      this.purchaseOrderApi
        .findOne({ where: { Service_Dispatch__c: this.modelId }, fields: { sfdcId: true } })
        .subscribe(order => {
          this.order = order;
          this.getPaymentDetails({ Purchase_Order__c: this.order.sfdcId });
        }, err => {
          this.errorMessage = err.message;
        });
    }
  }

  getPaymentDetails(query: any) {
    this.preloaderService.showPreloader();
    this.paymentApi
      .findOne({
        include: [
          { relation: 'invoice', scope: { include: ['vendor', 'timecard'] } },
          { relation: 'purchaseOrder', scope: { include: ['job'] } }
        ],
        where: query
      })
      .subscribe(payment => {
        this.payment = payment;
        this.errorMessage = Object.keys(this.payment).length > 0 ? '' : 'No payment details found.';
        this.preloaderService.hidePreloader();
      }, err => {
        this.errorMessage = err.message;
        this.preloaderService.hidePreloader();
      });
  }
}
